// src/utils/tableOfContents.js

// Export this function to be used in both places
export function createSlug(text) {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // Remove diacritics (accents)
    .replace(/[^\w\s-]/g, "") // Remove special characters except hyphens
    .trim()
    .replace(/\s+/g, "-"); // Replace spaces with hyphens
}

export function extractHeadings(blocks) {
  console.log("extractHeadings called with", blocks?.length || 0, "blocks");

  if (!blocks || !Array.isArray(blocks)) {
    console.error("extractHeadings: blocks is not an array", blocks);
    return [];
  }

  // Filter blocks for headings
  const headingBlocks = blocks.filter(
    (block) =>
      block._type === "block" && ["h2", "h3", "h4"].includes(block.style)
  );

  console.log("Found", headingBlocks.length, "heading blocks");

  if (headingBlocks.length === 0) {
    console.log("Sample of blocks:", blocks.slice(0, 3));
  }

  return headingBlocks.map((heading) => {
    // Extract text from all span children
    const text = heading.children
      .filter((child) => child._type === "span")
      .map((span) => span.text)
      .join("");

    console.log(`Processing heading: "${text}" (${heading.style})`);

    // Create slug from text
    const slug = createSlug(text);

    console.log(`Created slug: "${slug}"`);

    return {
      text,
      slug,
      level: parseInt(heading.style.substring(1)),
      style: heading.style,
    };
  });
}
